import { RelatedModel } from './models/RelatedModel';
import { ContentTypes } from '../../../constants/Enums';

export const getTagsFromRelated = (related: RelatedModel[]) => {
    if (related) {
        return related.filter((item) => item.type === ContentTypes.TAG);
    }

    return [];
};
